import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AiFillLinkedin,
  AiOutlineInstagram,
  AiOutlineMail,
  AiOutlineYoutube,
} from "react-icons/ai";
import { FaArrowRight, FaRegUserCircle, FaTiktok } from "react-icons/fa";
import { RiBriefcaseLine, RiFileTextLine, RiSparklingLine } from "react-icons/ri";

const VIOLETA = "#697B68";
const ROSA = "#E09767";

const SECTIONS = [
  {
    title: "Perfil",
    items: [
      {
        titulo: "Inicio",
        descripcion: "Presentación general y enfoque actual",
        url: "internal:/",
        icon: FaRegUserCircle,
      },
      {
        titulo: "Sobre mí",
        descripcion: "Experiencia, stack y casos con impacto",
        url: "internal:/sobre-mi",
        icon: RiBriefcaseLine,
      },
      {
        titulo: "TYR",
        descripcion: "Empresa y metodología aplicada a software, automatización e IA",
        url: "internal:/tyr",
        icon: RiSparklingLine,
      },
      {
        titulo: "Ver CV",
        descripcion: "Resumen profesional actualizado",
        url: "https://drive.google.com/file/d/1jgHbQDQlJLToev5Yn06qrox_4_TeR6n2/view?usp=sharing",
        icon: RiFileTextLine,
      },
      {
        titulo: "LinkedIn",
        descripcion: "Perfil profesional y experiencia",
        url: "https://www.linkedin.com/in/sebassotelo/",
        icon: AiFillLinkedin,
      },
    ],
  },
  {
    title: "Contenido",
    items: [
      {
        titulo: "YouTube",
        descripcion: "Desarrollo, IA y aprendizajes técnicos",
        url: "https://www.youtube.com/@SebassDev",
        icon: AiOutlineYoutube,
      },
      {
        titulo: "Instagram",
        descripcion: "Contenido corto y presencia personal",
        url: "https://www.instagram.com/_sebasdev/",
        icon: AiOutlineInstagram,
      },
      {
        titulo: "TikTok",
        descripcion: "Videos breves sobre desarrollo y tecnología",
        url: "https://www.tiktok.com/@sebassdev",
        icon: FaTiktok,
      },
    ],
  },
  {
    title: "Contacto",
    items: [
      {
        titulo: "Email",
        descripcion: "sotelosebasn@gmail.com",
        url: "mailto:sotelosebasn@gmail.com",
        icon: AiOutlineMail,
      },
    ],
  },
];

export default function Links() {
  const navigate = useNavigate();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Links | Sebas Sotelo | Perfil, TYR y contenido";
    setMounted(true);
  }, []);

  const backgroundStyle = {
    backgroundColor: "#EADFD2",
    backgroundImage: "linear-gradient(180deg, rgba(248,242,234,0.95) 0%, rgba(234,223,210,0.96) 100%)",
  };

  return (
    <div
      className="relative min-h-screen w-full overflow-hidden"
      style={backgroundStyle}
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(105,123,104,0.12) 1px, transparent 1px), linear-gradient(90deg, rgba(105,123,104,0.12) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />

      <main
        className="page-hero relative mx-auto flex min-h-screen w-full max-w-3xl flex-col items-center justify-start px-5 sm:px-8"
      >
        <div
          className={`mb-6 transition-all duration-1000 ${
            mounted ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"
          }`}
        >
          <button
            onClick={() => navigate("/")}
            className="group relative rounded-full outline-none"
            aria-label="Volver al Home"
          >
            <div
              className="absolute -inset-0.5 rounded-full opacity-70 blur-md transition-opacity group-hover:opacity-100"
              style={{
                background: `linear-gradient(135deg, ${ROSA}, ${VIOLETA})`,
              }}
            />
            <img
              src="/logo.png"
              alt="Sebas Sotelo"
              className="relative h-20 w-20 rounded-full object-cover ring-2 ring-[rgba(105,123,104,0.1)] transition-transform duration-300 group-hover:scale-105 sm:h-24 sm:w-24"
            />
          </button>
        </div>

        <div
          className={`mb-2 transition-all duration-1000 delay-100 ${
            mounted ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"
          }`}
        >
          <h1 className="section-title text-center tracking-tight">
            <span
              style={{
                background: `linear-gradient(135deg, ${ROSA}, ${VIOLETA})`,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              Sebas Sotelo
            </span>
          </h1>
        </div>

        <p
          className={`body-copy max-w-xl text-center transition-all duration-1000 delay-200 ${
            mounted ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"
          }`}
          style={{ color: `${VIOLETA}B3` }}
        >
          Perfil profesional, empresa, contenido y accesos clave en un solo lugar.
        </p>

        <div
          className={`mt-8 hidden w-full gap-3 sm:grid sm:grid-cols-3 transition-all duration-1000 delay-300 ${
            mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
        >
          {[
            "Full Stack Software Developer & AI Engineer",
            "TYR: software, automatización e IA",
            "Contenido y contacto directo",
          ].map((chip) => (
            <div
              key={chip}
              className="rounded-2xl px-4 py-3 text-center text-xs font-semibold"
              style={{
                backgroundColor: "rgba(255,255,255,0.82)",
                color: VIOLETA,
                border: `1px solid ${VIOLETA}12`,
              }}
            >
              {chip}
            </div>
          ))}
        </div>

        <div className="mt-8 w-full space-y-8">
          {SECTIONS.map((section, sectionIndex) => (
            <section
              key={section.title}
              className={`transition-all duration-1000 ${
                mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
              }`}
              style={{ transitionDelay: `${380 + sectionIndex * 120}ms` }}
            >
              <div className="mb-4 flex items-center gap-3">
                <div
                  className="h-[2px] w-10 rounded-full"
                  style={{
                    background: `linear-gradient(135deg, ${ROSA}, ${VIOLETA})`,
                  }}
                />
                <h2
                  className="text-sm font-bold uppercase tracking-[0.18em]"
                  style={{ color: `${VIOLETA}C0` }}
                >
                  {section.title}
                </h2>
              </div>

              <ul className="space-y-3">
                {section.items.map(({ titulo, descripcion, url, icon: Icon }, index) => {
                  const isInternal = url.startsWith("internal:");
                  const commonClasses =
                    "group relative flex w-full items-center gap-3 rounded-2xl border px-3.5 py-3.5 text-sm shadow-md transition-all duration-300 overflow-hidden hover:shadow-xl hover:-translate-y-0.5 sm:gap-4 sm:rounded-[1.75rem] sm:px-4 sm:py-4";
                  const commonStyle = {
                    backgroundColor: "rgba(255,255,255,0.9)",
                    borderColor: `${VIOLETA}1A`,
                    color: VIOLETA,
                  };

                  const content = (
                    <>
                      <span
                        className="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-xl text-white transition-transform duration-300 group-hover:scale-105 sm:h-11 sm:w-11 sm:rounded-2xl"
                        style={{
                          background: `linear-gradient(135deg, ${ROSA}, ${VIOLETA})`,
                        }}
                      >
                        <Icon className="text-lg" />
                      </span>

                      <span className="relative min-w-0 flex-1 text-left">
                        <span className="block text-base font-semibold">{titulo}</span>
                        <span
                          className="mt-1 hidden text-xs leading-relaxed sm:block"
                          style={{ color: `${VIOLETA}99` }}
                        >
                          {descripcion}
                        </span>
                      </span>

                      <span className="relative ml-auto flex h-8 w-8 items-center justify-center rounded-full bg-white/70 text-sm opacity-70 transition-all group-hover:opacity-100 group-hover:translate-x-0.5 sm:h-9 sm:w-9">
                        <FaArrowRight className="text-xs" />
                      </span>

                      <span
                        className="pointer-events-none absolute inset-0 rounded-[1.75rem] opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                        style={{
                          background: `linear-gradient(135deg, ${ROSA}12, ${VIOLETA}12)`,
                          mixBlendMode: "overlay",
                        }}
                      />
                    </>
                  );

                  return (
                    <li key={titulo}>
                      {isInternal ? (
                        <button
                          onClick={() => navigate(url.replace("internal:", ""))}
                          className={commonClasses}
                          style={commonStyle}
                        >
                          {content}
                        </button>
                      ) : (
                        <a
                          href={url}
                          target="_blank"
                          rel="noreferrer"
                          className={commonClasses}
                          style={commonStyle}
                        >
                          {content}
                        </a>
                      )}
                    </li>
                  );
                })}
              </ul>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
}
